import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getPlantMaster } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  GetPlantMasterRequestSchema,
  type GetPlantMasterResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 発電所マスタ full entity 取得 hook。
 * members を含む全フィールドを返す。Edit modal の form initial value に使用する。
 * id が undefined または空文字の場合は query を無効化する。
 */
export function useGetPlantMaster(
  id: string | undefined,
): UseQueryResult<GetPlantMasterResponse, ConnectError> {
  return useQuery(
    getPlantMaster,
    create(GetPlantMasterRequestSchema, { id: id ?? '' }),
    { enabled: id !== undefined && id !== '' },
  )
}
